import { createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../../api/apiServises';
import {ADD_CLEARANCE,LIST_CLEARANCE } from '../../../api/apiConstant';

export const addClearance = createAsyncThunk(
  'clearance/addClearance',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_CLEARANCE, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to clearance data',
      );
    }
  },
);

export const listClearance = createAsyncThunk(
  'clearance/listClearance',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await api.get(
        LIST_CLEARANCE,
        {
          params,
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
        error.message ||
        'Something Went Wrong.'
      );
    }
  },
);




